import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'On-Call',
  slug: 'on-call',
  definition: `On-call is a rotation system where team members take turns being the primary responder for incidents outside of normal working hours. The on-call engineer is responsible for acknowledging alerts and either resolving incidents or escalating them.

A healthy on-call rotation distributes the burden fairly across the team, typically in weekly shifts. It includes clear escalation paths for when the primary on-call is unavailable, and handoff procedures between shifts.

On-call is not just about nights and weekends. During business hours, having a designated incident responder ensures that alerts do not get lost in the noise of daily work.`,
  whyItMatters: `Without on-call, incidents that happen outside working hours go unnoticed until someone happens to check. That can mean hours of downtime for your users while your entire team is asleep.

A well-designed on-call rotation also prevents burnout. When the same person is always the one responding to incidents, they burn out quickly. Fair rotation and reasonable alert volume keep the team sustainable.`,
  howUptrackHelps: `Uptrack sends alerts through multiple channels — email, Slack, webhooks — so the on-call engineer is reached wherever they are. Fast detection with 30-second checks means the on-call team is notified quickly and can start working on the fix.

Confirmation checks reduce false alarms, which is critical for on-call quality of life. Nobody wants to be woken up at 2 AM for a transient network blip.`,
  relatedTerms: [
    { name: 'Alert Fatigue', href: '/glossary/alert-fatigue' },
    { name: 'Escalation Policy', href: '/glossary/escalation-policy' },
    { name: 'Incident Management', href: '/glossary/incident-management' },
    { name: 'MTTR', href: '/glossary/mttr' },
  ],
}

export const Route = createFileRoute('/_site/glossary/on-call')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
